import Rellax from 'rellax';

var sections = {};

const parallaxImage = {
  onLoad() {
    sections[this.id] = [];
    const frames = this.container.querySelectorAll('[data-parallax-wrapper]');
    frames.forEach((frame) => {
      const inner = frame.querySelector('[data-parallax-img]');
      sections[this.id].push(
        new Rellax(inner, {
          center: true,
          round: true,
          frame: frame,
        })
      );
    });
  },
  onUnload: function () {
    sections[this.id].forEach((image) => {
      if (typeof image.destroy === 'function') {
        image.destroy();
      }
    });
  },
};

export default parallaxImage;
